import React, { useEffect } from "react";
import { WS_URL } from "./apiConfig";

const SocketConnector = ({
  gameId,
  user,
  onMoveReceived,
  onGameUpdate,
  socketRef,
}) => {
  useEffect(() => {
    // If there is an existing WebSocket connection, close it
    if (socketRef.current) {
      socketRef.current.close();
      console.log("Existing WebSocket connection closed.");
    }

    // Create a new WebSocket connection
    socketRef.current = new WebSocket(`${WS_URL}`);


    socketRef.current.onopen = () => {
      console.log("WebSocket connected.");
      const message = JSON.stringify({ gameId, action: "getMoves" });
      socketRef.current.send(message);
    };

    socketRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("Received data from WebSocket:", data);

      if (data.type === "allMoves") {
        const moves = data.moves;
        moves.forEach((move) => {
          onMoveReceived(move.move_position, move.player_id);
        });
      } else if (data.type === "newMove") {
        const { move } = data;
        onMoveReceived(move.movePosition, move.playerId);
      } else if (data.type === "gameState") {
        onGameUpdate(data.gameState);
      }
    };

    socketRef.current.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    socketRef.current.onclose = () => {
      console.log("WebSocket disconnected.");
    };

    // Cleanup: Close WebSocket on component unmount
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
        console.log("WebSocket connection closed on unmount.");
      }
    };
  }); // Dependencies to trigger re-establishment of WebSocket

  return null; // No need to render anything from this component
};

export default SocketConnector;
